import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { HStack } from "@design-system/HStack/HStack";

interface EditModalFooterProps {
    onClose?: () => void;
    isValid: boolean;
    isSubmitting: boolean;
}

export const EditModalFooter: React.FC<EditModalFooterProps> = ({
    onClose,
    isValid,
    isSubmitting,
}) => (
    <HStack as="footer" justify="end" gap={12}>
        {onClose && (
            <Button
                variant="secondary"
                size="xl"
                type="button"
                onClick={onClose}
                disabled={isSubmitting}
            >
                Cancel
            </Button>
        )}

        <ButtonWithLoader
            variant="primary"
            size="xl"
            disabled={!isValid}
            loading={!!isSubmitting}
            type="submit"
        >
            Save
        </ButtonWithLoader>
    </HStack>
);
